// extracted by extract-css-chunks-webpack-plugin
module.exports = {"oos-message-container":"Hkdic","svg-icon":"_1-aHz","oos-message":"_26bcA"};